import { render, staticRenderFns } from "./VPSPwdLessLoginRootComponent.vue?vue&type=template&id=2f1e3b80"
import script from "./VPSPwdLessLoginRootComponent.vue?vue&type=script&lang=js"
export * from "./VPSPwdLessLoginRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports